import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/plugins/i18n.js';

// DDO Views
const Customers = () => import('@/views/customer/Customers')
const CustomerResellers = () => import('@/views/customer/CustomerResellers')
const Resellers = () => import('@/views/customer/Resellers')
const Slas = () => import('@/views/customer/Slas')
// const Catalog = () => import('@/views/Catalog')

const Certificates = () => import('@/views/certificate/Certificates')
const Vlans = () => import('@/views/network/Vlans')
const Networks = () => import('@/views/network/Networks')

const Products = () => import('@/views/catalog/Products')
//const Catalog = () => import('@/views/catalog/Catalog')
//const Catalog2 = () => import('@/views/pages/Catalog')

const Equipments = () => import('@/views/equipment/Equipments')
const LdapUsers = () => import('@/views/user/LdapUsers')
const Shortcodes = () => import('@/views/shortcode/Shortcodes')
const UserProfile = () => import('@/views/user/UserProfile')
const ExportsZoho = () => import('@/views/zoho/ExportsZoho')
const Invoices = () => import('@/views/zoho/Invoices')

const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const Checkout = () => import('@/views/pages/Checkout')

const PhysicalEquipments = () => import('@/views/monitoring/PhysicalEquipments')
const CertificateDeployments = () => import('@/views/monitoring/CertificateDeployments')
const CustomerContacts = () => import('@/views/monitoring/CustomerContacts')
const CustomerServiceSMTPPRO = () => import('@/views/monitoring/CustomerServiceSMTPPRO')
const Logs = () => import('@/views/monitoring/Logs')

const CustomerResellerServiceSMTPPRO = () => import('@/views/platform/CustomerResellerServiceSMTPPRO')
const CustomerResellerServiceSMSPRO = () => import('@/views/platform/CustomerResellerServiceSMSPRO')
const CustomerResellerServiceBACKUPBAREOS = () => import('@/views/platform/CustomerResellerServiceBACKUPBAREOS')

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

Vue.use(Router)

const router = new Router({
   mode: 'hash', // https://router.vuejs.org/api/#mode
   linkActiveClass: 'active',
   scrollBehavior: () => ({ y: 0 }),
   routes: [
      {
         path: '/',
         redirect: '/dashboard',
         name: 'Home',
         component: DefaultContainer,
         children: [
            {
               path: 'dashboard',
               name: i18n.t('nav.dashboard'),
               component: Dashboard
            },
            {
               path: 'myprofile',
               meta: { label: i18n.t('nav.myprofile') },
               component: {
                  render (c) { return c('router-view') }
               },
               children: [
                  {
                     path: '',
                     component: UserProfile,
                  },
               ]
            },
            {
               path: 'mycompany',
               meta: { label: i18n.t('nav.cus') },
               component: {
                  render (c) { return c('router-view') }
               },
               children: [
                  {
                     path: '',
                     meta: { label: i18n.t('nav.mycompany') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: Customers,
                        },
                     ]
                  },
               ]
            },
            {
               path: 'customerreseller',
               meta: { label: i18n.t('nav.monitoring_customerresellers') },
               component: {
                  render (c) { return c('router-view') }
               },
               children: [
                  {
                     path: '',
                     component: CustomerResellers,
                  },
               ]
            },
            {
               path: 'catalog',
               meta: { label: i18n.t('nav.catalog') },
               component: {
                  render (c) { return c('router-view') }
               },
               children: [
                  {
                     path: '',
                     //component: Catalog,
                  },
               ]
            },
            {
               path: 'platform',
               meta: { label: i18n.t('nav.plf') },
               component: {
                  render (c) { return c('router-view') }
               },
               children: [
                  {
                     path: 'servicesmtppro',
                     meta: { label: i18n.t('nav.monitoring_customerservicesmtppro') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: CustomerResellerServiceSMTPPRO,
                        },
                     ]
                  },
                  {
                     path: 'servicesmspro',
                     meta: { label: i18n.t('nav.monitoring_customerservicesmspro') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: CustomerResellerServiceSMSPRO,
                        },
                     ]
                  },
                  {
                     path: 'servicebackupbareos',
                     meta: { label: i18n.t('nav.monitoring_customerservicebackupbareos') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: CustomerResellerServiceBACKUPBAREOS,
                        },
                     ]
                  },
               ]
            },
            {
               path: 'monitoring',
               meta: { label: i18n.t('nav.monitoring') },
               component: {
                  render (c) { return c('router-view') }
               },
               children: [
                  {
                     path: 'log',
                     meta: { label: i18n.t('nav.monitoring_log') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: Logs,
                        },
                     ]
                  },
                  {
                     path: 'customerservicesmtppro',
                     meta: { label: i18n.t('nav.monitoring_customerservicesmtppro') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: CustomerServiceSMTPPRO,
                        },
                     ]
                  },
                  {
                     path: 'datacenters',
                     meta: { label: i18n.t('nav.monitoring_racks_in_dc') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: PhysicalEquipments,
                        },
                     ]
                  },
                  {
                     path: 'certificatedeployments',
                     meta: { label: i18n.t('nav.monitoring_certificatedeployments') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: CertificateDeployments,
                        },
                     ]
                  },
                  {
                     path: 'customercontacts',
                     meta: { label: i18n.t('nav.monitoring_customercontacts') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: CustomerContacts,
                        },
                     ]
                  },
               ]
            },
            {
               path: 'admin',
               meta: { label: i18n.t('nav.admin') },
               component: {
                  render (c) { return c('router-view') }
               },
               children: [
                  {
                     path: 'ldapusers',
                     meta: { label: i18n.t('nav.identities') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: LdapUsers,
                        },
                     ]
                  },
                  {
                     path: 'sla',
                     meta: { label: i18n.t('nav.sla') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: Slas,
                        },
                     ]
                  },
                  {
                     path: 'certificate',
                     meta: { label: i18n.t('nav.cer') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: Certificates,
                        },
                     ]
                  },
                  {
                     path: 'product',
                     meta: { label: i18n.t('nav.prc') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: Products,
                        },
                     ]
                  },
                  {
                     path: 'invoice',
                     meta: { label: i18n.t('nav.inv') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: Invoices,
                        },
                     ]
                  },
                  {
                     path: 'reseller',
                     meta: { label: i18n.t('nav.reseller') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: '',
                           component: Resellers,
                        },
                     ]
                  },
                  {
                     path: 'infra',
                     meta: { label: i18n.t('nav.infra') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: 'equipment',
                           meta: { label: i18n.t('nav.dtc') },
                           component: {
                              render (c) { return c('router-view') }
                           },
                           children: [
                              {
                                 path: '',
                                 component: Equipments,
                              },
                           ]
                        },
                        {
                           path: 'vlan',
                           meta: { label: i18n.t('nav.net') },
                           component: {
                              render (c) { return c('router-view') }
                           },
                           children: [
                              {
                                 path: '',
                                 component: Vlans,
                              },
                           ]
                        },
                        {
                           path: 'network',
                           meta: { label: i18n.t('nav.net') },
                           component: {
                              render (c) { return c('router-view') }
                           },
                           children: [
                              {
                                 path: '',
                                 component: Networks,
                              },
                           ]
                        },
                     ],
                  },      
                  {
                     path: 'settings',
                     meta: { label: i18n.t('nav.settings') },
                     component: {
                        render (c) { return c('router-view') }
                     },
                     children: [
                        {
                           path: 'shortcode',
                           meta: { label: i18n.t('nav.shc') },
                           component: {
                              render (c) { return c('router-view') }
                           },
                           children: [
                              {
                                 path: '',
                                 component: Shortcodes,
                              },
                           ]
                        },
                        {
                           path: 'exportszoho',
                           meta: { label: i18n.t('nav.zoho2prestige') },
                           component: {
                              render (c) { return c('router-view') }
                           },
                           children: [
                              {
                                 path: '',
                                 component: ExportsZoho,
                              },
                           ]
                        },
                     ]
                  },
               ]
            },
         ]
      },
      {
         path: '/pages',
         redirect: '/pages/404',
         name: 'Pages',
         component: {
            render (c) { return c('router-view') }
         },
         children: [
            {
               path: '404',
               name: 'Page404',
               component: Page404
            },
            {
               path: '500',
               name: 'Page500',
               component: Page500
            },
            {
               path: 'catalog',
               name: 'Catalog',
               //component: Catalog
            },
            {
               path: 'login',
               name: 'Login',
               component: Login
            },
            {
               path: 'logout',
               name: 'Logout',
               component: Login
            },
            {
               path: 'reset-password/:token',
               name: 'Reset Password',
               component: Login
            },
            {
               path: 'forgot-password',
               name: 'Forgot Password',
               //component: PasswordForgot
            },
            {
               path: 'checkout',
               name: 'Checkout',
               component: Checkout
            },
            {
               path: 'register',
               name: 'Register',
               component: Register
            }
         ]
      }
   ]
});

router.beforeEach( (to, from, next) => {
   console.log('beforeEach, from='+from.path+', to='+to.path);
   const publicPages = ['/pages/login', '/pages/catalog', '/catalog', '/pages/register', '/pages/checkout', '/pages/reset-password'];
   var authRequired = true;
   for ( var i=0; i<publicPages.length;i++ ) {
      if ( to.path.includes(publicPages[i]) ) {
         authRequired = false;
         console.log('beforeEach, scan='+publicPages[i]+' and set authRequired to '+authRequired);
         break;
      }
   }
   //var authRequired = !publicPages.includes(to.path);
   const currentSession = sessionStorage.getItem('session');
   var loggedIn = false;
   console.log('beforeEach, currentSession='+currentSession)
   if ( currentSession ) {
      loggedIn = true;
   }
   
   if (authRequired && !loggedIn) {
      console.log('beforeEach, next to /pages/login')
      return next('/pages/login');
   } else {
      console.log('beforeEach, next')
      return next();
   }
  //next();

});

export default router


